<p-confirmDialog styleClass="confirm-dialog"></p-confirmDialog>
<p-toast position="bottom-left"></p-toast>

<div class="clinical-forms-container" *ngIf="isVisible">
  <form [formGroup]="formsFormGroup" role="form" [attr.aria-label]="mode === 'view' && hcpcsCode ? 'Clinical questionnaire forms for ' + hcpcsCode : 'Clinical questionnaire forms'">
    <div class="forms-header">
      <h2 class="section-label">Clinical Questionnaire Form(s)</h2>
    </div>

    <div class="forms-table-wrapper">
      <p-table [value]="formsList.controls" styleClass="clinical-forms-table" [loading]="isLoading">
        <ng-template pTemplate="header">
          <tr>
            <th>Associated Form ID</th>
            <th>Associated Form Title</th>
            <th [ngClass]="{'text-center': mode === 'view'}">Shared Form</th>
            <th>Form Effective Start Date</th>
            <th><span class="sr-only">Actions</span></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-form let-i="rowIndex">
          <tr [formGroup]="getFormGroup(i)" 
              class="form-data-row"
              [class.editing-row]="isRowEditable(i)">
            <td class="form-id-cell">
              <span class="form-id-text">
                {{ getFormGroup(i).get('associatedFormId')?.value }}
              </span>
            </td>
            
            <td class="form-title-cell">
              <p-iconfield *ngIf="isRowEditable(i)">
                <p-inputicon styleClass="pi pi-search" />
                <p-autoComplete
                  formControlName="associatedFormTitle"
                  placeholder="Search"
                  [minLength]="1"
                  [suggestions]="filteredFormTitles"
                  (completeMethod)="onSearchFormTitles($event)"
                  (onSelect)="applyFormSelection($event.value, i)"
                  (onClear)="applyFormSelection('', i)"
                  [ngClass]="{'ng-invalid ng-dirty': getFormGroup(i).get('associatedFormTitle')?.invalid && getFormGroup(i).get('associatedFormTitle')?.touched}"
                  panelStyleClass="clinical-forms-autocomplete-panel"
                  appendTo="body">
                </p-autoComplete>
              </p-iconfield>
              <span *ngIf="!isRowEditable(i)">
                {{ getFormTitleDisplay(i) }}
              </span>
            </td>
            
            <td [ngClass]="{'text-center': mode === 'view'}">
              <p-select
                *ngIf="isRowEditable(i)"
                formControlName="sharedForm"
                [options]="isSharedFormOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Select"
                [class.p-invalid]="getFormGroup(i).get('sharedForm')?.invalid && getFormGroup(i).get('sharedForm')?.touched"
                appendTo="body">
              </p-select>
              <span *ngIf="!isRowEditable(i) && mode !== 'view'">
                {{ getFormGroup(i).get('sharedForm')?.value }}
              </span>
              <span *ngIf="!isRowEditable(i) && mode === 'view' && getFormGroup(i).get('sharedForm')?.value === 'Yes'" 
                    class="status-badge status-badge-success">
                <i class="pi pi-check"></i>
              </span>
              <span *ngIf="!isRowEditable(i) && mode === 'view' && getFormGroup(i).get('sharedForm')?.value === 'No'" 
                    class="status-badge status-badge-error">
                <i class="pi pi-times"></i>
              </span>
            </td>
            
            <td class="date-cell">
              <div class="date-field-wrapper" *ngIf="isRowEditable(i)">
                <p-datepicker
                  *ngIf="!isFormDateLocked(i)"
                  formControlName="formEffectiveStartDate"
                  dateFormat="mm/dd/yy"
                  [showIcon]="true"
                  placeholder="mm/dd/yyyy"
                  [class.p-invalid]="getFormGroup(i).get('formEffectiveStartDate')?.invalid && getFormGroup(i).get('formEffectiveStartDate')?.touched"
                  appendTo="body">
                </p-datepicker>
                <span *ngIf="isFormDateLocked(i)" class="date-text-locked">
                  {{ getFormGroup(i).get('formEffectiveStartDate')?.value | date:'MM/dd/yyyy' }}
                </span>
                <button
                  *ngIf="isFormDateLocked(i)"
                  type="button"
                  class="lock-icon-btn"
                  (click)="toggleFormDateLock(i)"
                  aria-label="Unlock Form Effective Date"
                  pTooltip="Click to unlock Form Effective Dates if they differ from CMS or Plan Effective Dates"
                  tooltipPosition="bottom">
                  <i class="pi pi-lock"></i>
                </button>
              </div>
              <span *ngIf="!isRowEditable(i)" class="date-text">
                {{ getFormGroup(i).get('formEffectiveStartDate')?.value | date:'MM/dd/yyyy' }}
              </span>
            </td>
            
            <td *ngIf="mode === 'view'" class="actions-cell">
              <button
                pButton
                pRipple
                type="button"
                label="Preview"
                icon="pi pi-external-link"
                class="p-button-text"
                (click)="previewForm(i)"
                aria-label="Preview">
              </button>
            </td>
            
            <td *ngIf="mode !== 'view'" class="actions-cell">
              <button
                pButton
                pRipple
                type="button"
                label="Preview"
                icon="pi pi-external-link"
                class="p-button-text mr-2"
                [disabled]="isRowEditable(i)"
                (click)="previewForm(i)"
                aria-label="Preview">
              </button>
              
              <ng-container *ngIf="!isRowEditable(i)">
                <button
                  type="button"
                  pButton
                  icon="pi pi-pencil"
                  class="p-button-text p-button-sm"
                  (click)="editForm(i)"
                  pTooltip="Edit"
                  tooltipPosition="top"
                  aria-label="Edit form">
                </button>
                <button
                  type="button"
                  pButton
                  icon="pi pi-trash"
                  class="p-button-text p-button-danger p-button-sm"
                  (click)="deleteForm(i)"
                  pTooltip="Delete"
                  tooltipPosition="top"
                  aria-label="Delete form">
                </button>
              </ng-container>
              
              <ng-container *ngIf="isRowEditable(i)">
                <button
                  type="button"
                  pButton
                  icon="pi pi-check"
                  class="p-button-text p-button-success p-button-sm"
                  (click)="saveForm(i)"
                  pTooltip="Save"
                  tooltipPosition="top"
                  aria-label="Save form">
                </button>
                <button
                  type="button"
                  pButton
                  icon="pi pi-times"
                  class="p-button-text p-button-secondary p-button-sm"
                  (click)="cancelForm(i)"
                  pTooltip="Cancel"
                  tooltipPosition="top"
                  aria-label="Cancel">
                </button>
              </ng-container>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr *ngIf="mode !== 'view'">
            <td colspan="5">
              <button
                type="button"
                pButton
                label="Add Form"
                icon="pi pi-plus"
                class="p-button-text p-button-sm p-button-primary add-form-btn"
                (click)="addForm()">
              </button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr *ngIf="mode === 'view'">
            <td colspan="5" class="text-center py-4">
              No clinical questionnaire forms available
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </form>
</div>

<p-dialog
  styleClass="w-7/12 clinical-forms-preview-dialog"
  [(visible)]="showPreviewDialog"
  (onHide)="closePreviewDialog()">
  <mnc-formio
    *ngIf="previewFormId"
    lazyComponent
    class="f-io"
    [form]="formData"
    [submission]="formSubmission"
    [readOnly]="true"
    (ready)="cdr.detectChanges()">
  </mnc-formio>
</p-dialog>
